// extracted by mini-css-extract-plugin
export default {"overrides":"dialog_overrides__zt9N8","title":"dialog_title__mh8uS","subtitle":"dialog_subtitle__i22zI"};